export enum SalesVoucherStatusEnum {
  Quotation = 1,
  SalesOrderConfirmed = 2,
  PaymentConfirmed = 3,
  SalesOrderDispatched = 4,
  Delivered = 5,
  Completed = 6,
  Voided = 7,
  PaymentSubmitted = 8,
  SOGenerated = 9,
  QuotationGenerated = 10,
  QuotationConfirmed = 11,
  Pending = 12,
  PartiallyConfirmed = 13,
  CancellationRequested = 14,
  ProcessingCancellationRequest = 15,
}
